import type { CURRENCYCODETYPE, IRequestPaymentReqData, TRANSACTION_TYPE } from 'BreetHelpers';

export type VERIFYTRANSACTIONSTAGETYPE = 'pin-verification' | 'otp-verification' | 'recovery-code' | 'exhausted-recovery-code';

export const verifyTransactionTitle: Record<VERIFYTRANSACTIONSTAGETYPE, string> = {
	'pin-verification': 'Email Authentication',
	'otp-verification': 'Verification',
	'recovery-code': 'Backup Code',
	'exhausted-recovery-code': 'Backup Code Exhausted',
};

export interface IDIALOGVERIFYTRANSACTIONPROPS {
	transactionType: TRANSACTION_TYPE;
	withdrawFiatReqData?: IRequestPaymentReqData;
	convertFiatToUSDReqData?: {
		amount: number;
		withdrawalAddressId?: string;
		pin?: string;
	};
	swapCurrencyReqData?: {
		amount: number;
		from: Lowercase<CURRENCYCODETYPE>;
		to: Lowercase<CURRENCYCODETYPE>;
		pin?: string;
	};
	withdrawUSDReqData?: {
		amount: number;
		walletId: string;
		pin?: string;
	};
}
